import React from 'react';
import { Facebook, Twitter, Linkedin, Link2, Share2 } from 'lucide-react';
import { toast } from 'sonner';

const SITE_URL = 'https://bethtokens.com/pas';
const SHARE_TEXT = 'BETHCOIN Exchange Market - You Are The Banker Now! Open a BETH wallet, mint digital crypto checks with SHA-256 signatures. IRC 1031 compliant. 💰🔐';
const SHARE_HASHTAGS = 'BETHCOIN,Crypto,DigitalChecks,Blockchain,DeFi';

export const ShareButtons = ({ url = SITE_URL, text = SHARE_TEXT, className = '' }) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedText = encodeURIComponent(text);
  
  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedText}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}&hashtags=${SHARE_HASHTAGS}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Link copied to clipboard!');
    } catch (e) {
      toast.error('Failed to copy link');
    }
  };

  const openShare = (platform) => {
    window.open(shareLinks[platform], '_blank', 'width=600,height=400');
  };

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="share-buttons">
      <span className="text-slate-400 text-sm font-medium flex items-center gap-1">
        <Share2 className="w-4 h-4" /> Share:
      </span>
      <button
        onClick={() => openShare('facebook')}
        className="w-9 h-9 flex items-center justify-center rounded-full bg-blue-600 hover:bg-blue-700 text-white transition-colors"
        title="Share on Facebook"
        aria-label="Share on Facebook"
        data-testid="share-facebook"
      >
        <Facebook className="w-4 h-4" />
      </button>
      <button
        onClick={() => openShare('twitter')}
        className="w-9 h-9 flex items-center justify-center rounded-full bg-sky-500 hover:bg-sky-600 text-white transition-colors"
        title="Share on Twitter"
        aria-label="Share on Twitter"
        data-testid="share-twitter"
      >
        <Twitter className="w-4 h-4" />
      </button>
      <button
        onClick={() => openShare('linkedin')}
        className="w-9 h-9 flex items-center justify-center rounded-full bg-blue-700 hover:bg-blue-800 text-white transition-colors"
        title="Share on LinkedIn"
        aria-label="Share on LinkedIn"
        data-testid="share-linkedin"
      >
        <Linkedin className="w-4 h-4" />
      </button>
      <button
        onClick={copyLink}
        className="w-9 h-9 flex items-center justify-center rounded-full bg-slate-700 hover:bg-slate-600 text-white transition-colors"
        title="Copy link"
        aria-label="Copy link to clipboard"
        data-testid="share-copy"
      >
        <Link2 className="w-4 h-4" />
      </button>
    </div>
  );
};

// Compact version for mobile/smaller spaces
export const ShareButtonsCompact = ({ url = SITE_URL, className = '' }) => {
  const encodedUrl = encodeURIComponent(url);
  
  const shareFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`, '_blank', 'width=600,height=400');
  };

  return (
    <button
      onClick={shareFacebook}
      className={`px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium flex items-center gap-2 transition-colors ${className}`}
      data-testid="share-facebook-btn"
    >
      <Facebook className="w-4 h-4" /> Share on Facebook
    </button>
  );
};

export default ShareButtons;
